module.exports = __webpack_public_path__ + "static/media/worldwide.44de1602.svg";